const STALE_CHUNK_RELOAD_KEY = 'resq.stale-chunk-reload-at';
const STALE_CHUNK_RELOAD_COOLDOWN_MS = 5 * 60 * 1000;
const DYNAMIC_IMPORT_FAILURE =
    /^(?:Failed to fetch dynamically imported module|error loading dynamically imported module): (https?:\/\/\S+)$/i;
const VITE_ASSET_PATH = /^\/assets\/[^/]+\.[A-Za-z0-9_-]{8,}\.js$/;

interface StaleChunkRecoveryEnvironment {
    now: () => number;
    origin: string;
    reload: () => void;
    storage: Pick<Storage, 'getItem' | 'setItem'>;
}

const getErrorMessage = (error: unknown) => {
    if (error instanceof Error) {
        return error.message;
    }
    return typeof error === 'string' ? error : '';
};

export const reloadForStaleChunk = (
    error: unknown,
    environment?: StaleChunkRecoveryEnvironment,
) => {
    const match = DYNAMIC_IMPORT_FAILURE.exec(getErrorMessage(error));
    if (!match) {
        return false;
    }

    try {
        const browserEnvironment = environment ?? {
            now: Date.now,
            origin: window.location.origin,
            reload: () => window.location.reload(),
            storage: window.sessionStorage,
        };
        const assetUrl = new URL(match[1]);
        if (
            assetUrl.origin !== browserEnvironment.origin ||
            !VITE_ASSET_PATH.test(assetUrl.pathname)
        ) {
            return false;
        }

        const lastReloadAt = Number(browserEnvironment.storage.getItem(STALE_CHUNK_RELOAD_KEY));
        const now = browserEnvironment.now();
        if (lastReloadAt > 0 && now - lastReloadAt < STALE_CHUNK_RELOAD_COOLDOWN_MS) {
            return false;
        }

        browserEnvironment.storage.setItem(STALE_CHUNK_RELOAD_KEY, String(now));
        browserEnvironment.reload();
        return true;
    } catch {
        return false;
    }
};
